import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzNpday80 } from './pages'

type TIdToPageMapWoofzNpday80 = Record<PageIdWoofzNpday80, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_NPDAY_80: TIdToPageMapWoofzNpday80 = {
  [PageId.SUBSCRIPTIONS_NPDAY_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_80/pages/subscriptions/SubscriptionNpday80'
      ).then((m) => ({
        default: m.SubscriptionsNpday80,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_80/pages/subscriptions/SubscriptionNpday80'
      ),
  },
  [PageId.CHAT_UPSELL_NPDAY_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_80/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_80/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_NPDAY_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_80/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_npday/woofz_npday_80/pages/upsell/Upsell'),
  },
  [PageIdWoofzNpday80.DOWNLOAD_NPDAY_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_80/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_80/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzNpday80.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
